import { tp } from '../../../i18n/useP';
// Standard revenue pack — 9 typical billing lines for a Swiss SME services
// firm. Used by the "Charger le jeu standard" entry in AddRevenueMenu.
//
// Total HT visible ≈ 246 KCHF, excluding Conseil régie (manual), Commissions
// (manual) and Forfait projet (kept at 0 — user enters total + milestones).

import { applyPreset } from './presets';

export const STANDARD_REVENUE_PACK = [
  {
    label: tp('phrases:p_174d305a9c'),
    detail: tp('phrases:p_6be9e9acf6'),
    monthly_values: applyPreset('timeAndMaterial'),
    payment_lag: 1,
    vat_applicable: true,
  },
  {
    label: tp('phrases:p_81716c8378'),
    detail: tp('phrases:p_2f52206455'),
    monthly_values: applyPreset('fixedPrice', { totalAmount: 0, milestones: [{ month: 0, pct: 30 }, { month: 3, pct: 40 }, { month: 6, pct: 30 }] }),
    payment_lag: 1,
    vat_applicable: true,
  },
  {
    label: tp('phrases:p_fd962dd8b2'),
    detail: tp('phrases:p_87c9753456'),
    monthly_values: applyPreset('recurring', { monthlyAmount: 5000 }),
    payment_lag: 1,
    vat_applicable: true,
  },
  {
    label: tp('phrases:p_a5479753e0'),
    detail: tp('phrases:p_53234cff37'),
    monthly_values: applyPreset('hourBank', { totalAmount: 60000, months: [0] }),
    payment_lag: 1,
    vat_applicable: true,
  },
  {
    label: tp('phrases:p_df5f15c5a0'),
    detail: tp('phrases:p_f10a189285'),
    monthly_values: applyPreset('licenseAnnual', { annualAmount: 24000, paymentMonth: 0 }),
    payment_lag: 1,
    vat_applicable: true,
  },
  {
    label: tp('phrases:p_ce59479bb9'),
    detail: tp('phrases:p_5f3e290317'),
    monthly_values: applyPreset('recurring', { monthlyAmount: 3000 }),
    payment_lag: 1,
    vat_applicable: true,
  },
  {
    label: tp('phrases:p_325a218a18'),
    detail: tp('phrases:p_4486dfe2e6'),
    monthly_values: applyPreset('seasonal', { annualAmount: 60000, pattern: 'q4_peak' }),
    payment_lag: 1,
    vat_applicable: true,
  },
  {
    label: tp('phrases:p_22a0185ec2'),
    detail: tp('phrases:p_bbb87b75e0'),
    monthly_values: applyPreset('variable'),
    payment_lag: 2,
    vat_applicable: true,
  },
  {
    label: tp('phrases:p_1c01fa9c6d'),
    detail: '',
    monthly_values: applyPreset('recurring', { monthlyAmount: 500 }),
    payment_lag: 1,
    vat_applicable: true,
  },
];
